{
    "watchForFileChanges" : false,
    "baseUrl" : "https://web.inbooma.net",
    "viewportWidth": 1100,
    "viewportHeight": 700,
    "video": false
}

